import type { FC } from 'react';

import { Typography, useTheme } from '@mui/material';

import useFixFileName from '@shared/hooks/useFixFileName';

import { FileName, FileNameContainer } from './Caption.style';

import type { MediaType } from '@shared/models/media.model';

type CaptionPropsType = {
  attachmentsItem: MediaType;
  id?: string;
};
export const Caption: FC<CaptionPropsType> = (props) => {
  const { attachmentsItem, id = 'fileName' } = props;

  const theme = useTheme();
  const { fixFileName } = useFixFileName();

  const fileSize = attachmentsItem?.size ? `${(attachmentsItem.size / 1000000).toFixed(2)} MB` : '';

  const fileName = attachmentsItem?.original_filename
    ? fixFileName(attachmentsItem.original_filename, 20, '.')
    : '';

  return (
    <FileNameContainer id={id}>
      <FileName noWrap variant="t12m">
        {fileName}
      </FileName>
      <Typography noWrap sx={{ color: theme.palette.case.neutral.n500 }} variant="t10m">
        {fileSize}
      </Typography>
    </FileNameContainer>
  );
};
